"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class BlockedLocationsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            BlockedLocation: () => `
        ... on BlockedLocation {
          id
          ip
          city
          countryCode
          stateCode
          date
          type
        }
      `,
            BlockedLocationAutocomplete: () => `
        ... on BlockedLocationAutocomplete {
          city
          stateCode
          countryCode
        }
      `,
        };
    }
    search({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("blockedLocationsSearch", { data }, `
      result {
        ${this.getFragment("BlockedLocation")}
      }
      hasNextPage
      hasPrevPage
      page
      size
      totalPages
      totalRecords
    `);
        });
    }
    create({ userId, data: location, }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("blockedLocationsAdd", { userId, location }, this.getFragment("BlockedLocation"));
        });
    }
    delete({ id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("blockedLocationsDelete", { id });
        });
    }
    searchAutocomplete({ text }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("blockedLocationsAutocomplete", { text }, this.getFragment("BlockedLocationAutocomplete"));
        });
    }
    getStats({ userId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // TODO Move info to graphql
            return { info: yield this.query("statsBlockedLocations", { id: userId }) };
        });
    }
}
exports.BlockedLocationsProvider = BlockedLocationsProvider;
//# sourceMappingURL=BlockedLocationsProvider.js.map